import { FileListItemSkeleton } from '../../../File'
import { Skeleton } from '../../../Skeleton'

import * as styles from './EmailProfileMessageBodyAttachedFilesSkeleton.module.css'

function EmailProfileMessageBodyAttachedFilesSkeleton({
  className = styles.EmailProfileMessageBodyAttachedFilesSkeleton,
}) {
  return (
    <div className={className}>
      <div className={styles.header}>
        <Skeleton className={styles.title} />
        <Skeleton className={styles.downloadAllButton} />
      </div>
      <div className={styles.fileList}>
        {Array.from({ length: 3 }).map((_, index) => (
          <FileListItemSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}

export default EmailProfileMessageBodyAttachedFilesSkeleton
